import { FieldType, FormFieldType, FormsResultsDTO } from '../types/forms';
import { FormResult } from '../components/FormsResultsTable/FormsResultsTable';

export const unifyFormTypes = (fieldType: FieldType, isFormulaField: boolean, formula: string, potionsCount: number): FormFieldType => {
    if (isFormulaField && formula && formula.length > 0) {
        return 'formula';
    }

    switch (fieldType) {
        case 'string':
        case 'number':
        case 'date':
        case 'color':
            return fieldType;
        case 'text':
        case 'json':
        case 'url':
            return 'text';
        case 'hidden':
            return 'password';
        case 'bool':
            return 'radio';
        case 'enumerated':
        case 'orderedset':
            if (potionsCount < 4) {
                return 'radio';
            }
            return 'select';
        case 'zipcode':
            return 'number';
        case 'geoloc':
            return 'text';
    }
};

export const transformFormFields = (
    data: any[],
    values: {
        [key: string]: string | number | null
    } = {},
) => {
    return data.map(item => {
        return {
            id: item.id || item.fieldID || item.name,
            fieldID: item.fieldID,
            label: item.title,
            name: item.name || item.id,
            group: item.group,
            type: unifyFormTypes(item.type, item.calculated, item.formula, item.options?.length || 0),
            hidden: item.hidden || false,
            required: item.required || false,
            options: item.options,
            defaultValue: values[item.id] || item.defaultValue || undefined,
            formula: item.formula ? item.formula : '',
            calculated: item.calculated || false,
        };
    });
};

export const transformFormResponses = (responses: FormsResultsDTO['responses']): FormResult[] => {
    return responses.map(response => {
        const responseData: Record<string, any> = {};
        response.response.forEach(item => {
            responseData[item.id] = item.value;
        });

        return {
            id: response.response_id,
            date: response.date,
            userEmail: response.user?.email || '-',
            ...responseData,
        };
    });
};
